import { render, staticRenderFns } from "./Annotator.vue?vue&type=template&id=ee6af9a6"
import script from "./Annotator.vue?vue&type=script&lang=js"
export * from "./Annotator.vue?vue&type=script&lang=js"
import style0 from "./Annotator.vue?vue&type=style&index=0&id=ee6af9a6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports